"use strict";

const ValueCache = require('./ValueCache');

const ValuesCache = require('./ValuesCache');

function memoize(calc, options = {}) {
  const cache = new ValueCache(options);
  return (...args) => {
    return cache.calc(calc, ...args);
  };
}

exports.ValueCache = ValueCache;
exports.ValuesCache = ValuesCache;
exports.memoize = memoize;